const meta = {
  module: "specialities",
};

export default [
  {
    path: `/specialities`,
    redirect: "/specialities/page/1",
  },
  {
    path: `/specialities/page`,
    redirect: "/specialities/page/1",
  },
  {
    path: `/specialities/page/:page`,
    name: "specialities",
    component: () =>
      import(
        /* webpackChunkName: "specialities" */ "@/modules/specialities/views/index.vue"
      ),
    meta: {
      ...meta,
    },
  },
  {
    path: `/specialities/create`,
    name: "specialities/create",
    component: () =>
      import(
        /* webpackChunkName: "specialities/create" */ "@/modules/specialities/views/create.vue"
      ),
    meta: {
      ...meta,
      action: "create",
    },
  },
  {
    path: `/specialities/edit/:id`,
    name: "specialities/edit",
    component: () =>
      import(
        /* webpackChunkName: "specialities/edit" */ "@/modules/specialities/views/edit.vue"
      ),
    meta: {
      ...meta,
      action: "edit",
    },
  },
];
